var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEducationWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.499,
    height: 31.5,
    viewBox: "0 0 40.499 31.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-book-open",
    "data-name": "Icon awesome-book-open",
    d: "M38.125,2.254c-3.853.219-11.512,1.015-16.239,3.909a1.081,1.081,0,0,0-.511.926V32.673a1.113,1.113,0,0,0,1.637.949c4.864-2.448,11.9-3.116,15.377-3.3A2.193,2.193,0,0,0,40.5,28.166V4.412a2.2,2.2,0,0,0-2.374-2.159ZM18.614,6.162C13.887,3.268,6.228,2.473,2.375,2.254A2.205,2.205,0,0,0,0,4.412V28.167a2.192,2.192,0,0,0,2.111,2.156c3.48.183,10.518.851,15.382,3.3a1.109,1.109,0,0,0,1.632-.946V7.076A1.059,1.059,0,0,0,18.614,6.162Z",
    transform: "translate(0 -2.25)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducationWhite);
export default __webpack_public_path__ + "static/media/education-white.ebdce8efdde631447c3e700b7e5f2336.svg";
export { ForwardRef as ReactComponent };